import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";

import "./ChatScreen.css";

function ChatScreen() {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    {
      name: "Riri",
      image:
        "https://dailypost.ng/wp-content/uploads/2019/06/13430CF4-6F37-449A-AD7B-A9285C375E8A.jpeg",
      message: "What's up Ola 💞",
    },
    {
      name: "Riri",
      image:
        "https://dailypost.ng/wp-content/uploads/2019/06/13430CF4-6F37-449A-AD7B-A9285C375E8A.jpeg",
      message: "How about a date tonight? 😉",
    },
    {
      message: "I'm up for it gal 😍",
    },
  ]);

  const handleClick = (e) => {
    e.preventDefault();

    setMessages([...messages, {message: input}])
    setInput("")
  };

  return (
    <div className="chatScreen">
      <p className="chatScreen__timestamp">You Matched With Riri on 14/02/20</p>
      {messages.map((message) =>
        message.name ? (
          <div className="chatScreen__message">
            <Avatar
              className="chatScreen__image"
              alt={message.name}
              src={message.image}
            />
            <p className="chatScreen__text">{message.message}</p>
          </div>
        ) : (
          <div className="chatScreen__message">
            <p className="chatScreen__textUser">{message.message}</p>
          </div>
        )
      )}

      <form className="chatScreen__input">
        <input
          onChange={(e) => setInput(e.target.value)}
          value={input}
          className="chatScreen__inputField"
          type="text"
          placeholder="Type a message..."
          autoFocus="false"
        />
        <button
          type="submit"
          className="chatScreen__send"
          onClick={handleClick}
        >
          SEND
        </button>
      </form>
    </div>
  );
}

export default ChatScreen;
